<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount" [lazy]="true" (onLazyLoad)="lazyLoad($event)" [loading]="loading">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Name">
          {{ 'common.name' | translate | titlecase }}
          <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th class="actions-column"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-savedQuery>
      <tr>
        <td>
          <div class="mr-12 mct-flex mct-row">
            <div class="mct-flex mct-justify-start mct-items-center mct-fill">{{ savedQuery.Name }}</div>
            <div [hidden]="!savedQuery.Descr" tooltipPosition="top" [pTooltip]="savedQuery.Descr" hideDelay="500"
              tooltipStyleclass="mct-flex atlas-tooltip mct-justify-end mct-items-center">
              <i class="pi pi-info-circle text-primary"></i>
            </div>
          </div>
        </td>
        <td class="t-ac">
          <a (click)="exportQuery(savedQuery)">{{ 'reports.saved-queries.export-data' | translate | titlecase }}</a> •
          <a (click)="openInProfileSelector(savedQuery)">{{ 'reports.saved-queries.open-in-profile-selector' | translate
            }}</a> •
          <a (click)="openEditQuery(savedQuery)">{{ 'reports.saved-queries.edit-query' | translate | titlecase }}</a>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()"
      appendTo="body">
    </p-select>
  </div>
</div>

<p-dialog #dataParameters modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false"
  [(visible)]="showDatePrompt">
  <ng-template pTemplate="header">
    {{ 'reports.saved-queries.date-parameters' | translate | titlecase }}
  </ng-template>
  <div *ngIf="currentQuery?.DateParameters != null">
    <div class="mct-grid mct-cols-1-1-1" *ngFor="let param of currentQuery.DateParameters">
      <div class="mct-flex mct-row mct-justify-center mct-items-center">{{ param.Name }}</div>
      <div class="mct-flex mct-row mct-justify-center mct-items-center">{{ param.Comparer }}</div>
      <div class="mct-flex mct-row mct-justify-center mct-items-end">
        <wl-date-selector [(ngModel)]="param.Value" appendTo="body"></wl-date-selector>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="showDatePrompt = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary ml-10" (click)="acceptDateParams()">
      {{ 'reports.saved-queries.use-selected' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
